module.exports = __webpack_public_path__ + "img/tr.e222f4f7.jpg";